import { useState } from 'react';
import { Button, Modal, Box, CircularProgress, Typography, Grid, Autocomplete, Select, MenuItem, Checkbox, TextField } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import { axiosInstance } from 'utils/axios';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const InsertDriverRecord = ({ driverCarTypeID, driverCurrentStatus }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    console.log('This is driver current status = ', driverCurrentStatus);

    const [updateName, setupdateName] = useState('');
    const [updatePlateNo, setupdatePlateNo] = useState('');
    const [updateRating, setupdateRating] = useState(0);
    const [updateCartTypeID, setupdateCartTypeID] = useState(1);
    const [updateCurrentStatusID, setupdateCurrentStatusID] = useState(1);
    const [updateActive, setupdateActive] = useState(false);
    const [createStartWorkDate, setcreateStartWorkDate] = useState(dayjs(''));
    const [createEndWorkDate, setCreateEndWorkDate] = useState(dayjs(''));

    const [insertBtnDisabled, setInsertBtnDisabled] = useState(false);
    const [insertTasklistLoading, setInsertTasklistLoading] = useState(false);

    const insertDriver = async () => {
        setInsertBtnDisabled(true);
        setTimeout(() => {
            setInsertBtnDisabled(false);
        }, 3000);
        setInsertTasklistLoading(true);
        console.log("dist doesn't ran");
        try {
            const res = await axiosInstance.post(
                '/Driver',
                {
                    name: updateName,
                    plateNo: updatePlateNo,
                    rating: parseFloat(updateRating),
                    carTypeID: updateCartTypeID,
                    currentStatusID: updateCurrentStatusID,
                    startWorkDateTime: createStartWorkDate.toISOString(),
                    endWorkDateTime: createEndWorkDate.toISOString(),
                        active: updateActive
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Driver Inserted successfully.');
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setInsertTasklistLoading(false);
        }
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: deepPurple[500],
                    color: 'white',
                    marginLeft: 'auto',
                    marginBottom: '20px',
                    marginRight: '20px'
                }}
            >
                Insert Driver
            </Button>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {insertTasklistLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Insert Customer Tasklist
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>
                        <Box
                            id="modal-modal-description"
                            sx={{
                                height: '450px',
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Name :
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={updateName}
                                            onChange={(e) => setupdateName(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            plate No :
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={updatePlateNo}
                                            onChange={(e) => setupdatePlateNo(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Rating :
                                        </Typography>
                                        <input
                                            type="number"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={updateRating}
                                            onChange={(e) => setupdateRating(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Car Type ID :
                                        </Typography>
                                        <Select
                                            displayEmpty
                                            value={updateCartTypeID}
                                            onChange={(e) => setupdateCartTypeID(e.target.value)}
                                            // sx={{width:"100%"}}
                                        >
                                            <MenuItem sx={{ width: '100%' }} value="0">
                                                Select Status
                                            </MenuItem>
                                            {driverCarTypeID.map((item, index) => (
                                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Current Status ID :
                                        </Typography>
                                        <Select
                                            displayEmpty
                                            value={updateCurrentStatusID}
                                            onChange={(e) => setupdateCurrentStatusID(e.target.value)}
                                            // sx={{width:"100%"}}
                                        >
                                            <MenuItem sx={{ width: '100%' }} value="0">
                                                Select Status
                                            </MenuItem>
                                            {driverCurrentStatus.map((item, index) => (
                                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Start Work Date :
                                        </Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                value={createStartWorkDate}
                                                onChange={(newValue) => setcreateStartWorkDate(newValue)}
                                                renderInput={(props) => <TextField {...props} />}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            End Work Date :
                                        </Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                value={createEndWorkDate}
                                                onChange={(newValue) => setCreateEndWorkDate(newValue)}
                                                renderInput={(props) => <TextField {...props} />}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '50px'
                            }}
                            onClick={() => insertDriver()}
                            disabled={insertBtnDisabled}
                        >
                            Insert Drivers
                        </Button>
                    </Box>
                )}
            </Modal>
        </>
    );
};

export default InsertDriverRecord;
